import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { Text } from '@carnica/ui-kit';
import { enhancedConnect } from "../../../../utils";
import styles from "./styles.pcss";
import { StepsSlideContext } from "../../context";
var cx = classNames.bind(styles);
var _PrimarySlide = function _PrimarySlide(_ref) {
  var text = _ref.text,
    image = _ref.image,
    imagePopup = _ref.imagePopup,
    imagePopupBottom = _ref.imagePopupBottom,
    children = _ref.children,
    _ref$innerSize = _ref.innerSize,
    innerSize = _ref$innerSize === void 0 ? 'default' : _ref$innerSize;
  var _React$useContext = React.useContext(StepsSlideContext),
    isActive = _React$useContext.isActive;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('slide', {
      'slide-active': isActive
    }),
    "data-t-id": "slides-PrimarySlide"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('card', "innerSize--".concat(innerSize))
  }, Boolean(image) && /*#__PURE__*/React.createElement("div", {
    className: cx('image')
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: image
  }), Boolean(imagePopup) && /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('image-popup'),
    src: imagePopup,
    style: {
      bottom: "".concat(imagePopupBottom || 0, "%")
    }
  })), Boolean(text) && /*#__PURE__*/React.createElement(Text, {
    className: cx('text')
  }, text), children));
};
export var PrimarySlide = compose(enhancedConnect({
  text: PropTypes.string,
  image: PropTypes.string,
  imagePopup: PropTypes.string,
  imagePopupBottom: PropTypes.number,
  innerSize: PropTypes.oneOf(['default', 'full']),
  children: PropTypes.node
}), withAutoMetric.Item(function (_ref2) {
  var text = _ref2.text;
  return {
    name: 'PrimarySlide',
    title: text
  };
}))(_PrimarySlide);